import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import I18n from '@src/i18n';
import styled from '@src/styled-components';
import { I18n } from 'aws-amplify';
import React from 'react';

interface propType {
  visible: boolean;
  onCancel: Function;
}

const ConnectionModeAlert = (props: propType) => {
  return (
    <AlertWrapper visible={props.visible}>
      <div className="content">
        <FontAwesomeIcon style={{width: 28, height: 28}}icon='link' />
        <h3>{I18n.l('workflow.connection.mode')}</h3>
      </div>
      <span>
        {I18n.l('common.or')}
      </span>
      <div className="content">
        <button onClick={props.onCancel} className="cancel-button">{I18n.l('cancel.connection')}</button>
      </div>
    </AlertWrapper>
  )
}

const AlertWrapper = styled.div`
    visibility: ${props => props.visible ? '' : 'hidden'};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 40%;
    height: 120px;
    position: absolute;
    bottom: 200px;
    left: 50%;
    margin-left: -20%;
    border-radius: 5px;
    background-color: #ffffff;
    z-index: 1;
    box-shadow: 2px 2px 2px #9c9b9aa1;
    
    span{
      margin: 8px 0;
      font-size: 1.3em;
    }
    .cancel-button{
      background: none;
      border: none;
      font-size: 1.3em;
      color: #335d7c;
      font-weight: 600;
      :hover{
        cursor: pointer;
      }
    }
    .content{
      display: flex;
      align-items: center;
      justify-content: center;
      h3{
        margin: 0px 0 0 18px;
        font-size: 1.5em;
      }
    }
`

export default ConnectionModeAlert